import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

const getSafeState = (state: RootState) => {
  return state.toastNotifications;
};

export const getToastNotificationsCurrentMessageSelector = createSelector(getSafeState, (state) => {
  return state.current;
});
